<template>
    <page>
		<module enable-flex>
			<div class="welcome flex-grow flex-center">
				<img src="@/assets/image/welcome.png" alt="">
			</div>
		</module>
    </page>
</template>

<script>
	import charts from '@/components/charts/index.vue'
    import {mapGetters} from 'vuex'

	export default {
		name: 'home',
		
		components: {
			charts
		},
		
		data() {
			return {
            }
		},
        computed: {
        },

        mounted() {
        },


        methods: {

        }
	}
</script>

<style lang="stylus" scoped>
	.welcome {
		img {
			width: 1000px;
		}
	}
</style>
